// Auto generated file, do not manually modify!
// com.hotpads.renterinfo.web.api.web.v1.renterprofile.RenterInfoRenterProfileWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  RenterInfoRenterProfileGetForPostLeadFormWebApiResponseDto,
  RenterInfoRenterProfileInsertOrUpdateForPostLeadFormWebApiRequestDto,
  RenterInfoRenterProfileInsertOrUpdateForPostLeadFormWebApiResponseDto,
  RenterInfoRenterProfileInsertOrUpdateForStandaloneRequestDto,
  RenterInfoRenterProfileStandalonePageWebApiResponse,
} from '../..';

export const RenterInfoRenterProfileWebApiHandler_getForPostLeadForm_Path =
  '/api/web/v1/renterProfile/getForPostLeadForm';

/**
 * Get renter profile for post lead form
 */
export const RenterInfoRenterProfileWebApiHandler_getForPostLeadForm = (client = getClient()) => {
  return httpFrontEndRequest<never, never, RenterInfoRenterProfileGetForPostLeadFormWebApiResponseDto>(
    {
      endpoint: RenterInfoRenterProfileWebApiHandler_getForPostLeadForm_Path,
      method: 'GET',
      contextPath: '/renter-info',
    },
    client,
  );
};

export const RenterInfoRenterProfileWebApiHandler_getForStandalonePage_Path =
  '/api/web/v1/renterProfile/getForStandalonePage';

/**
 * Get renter profile for standalone page
 */
export const RenterInfoRenterProfileWebApiHandler_getForStandalonePage = (client = getClient()) => {
  return httpFrontEndRequest<never, never, RenterInfoRenterProfileStandalonePageWebApiResponse>(
    {
      endpoint: RenterInfoRenterProfileWebApiHandler_getForStandalonePage_Path,
      method: 'GET',
      contextPath: '/renter-info',
    },
    client,
  );
};

export const RenterInfoRenterProfileWebApiHandler_insertOrUpdateForPostLeadForm_Path =
  '/api/web/v1/renterProfile/insertOrUpdateForPostLeadForm';

/**
 * Insert or update renter profile for post lead form
 */
export const RenterInfoRenterProfileWebApiHandler_insertOrUpdateForPostLeadForm = (
  postData: RenterInfoRenterProfileInsertOrUpdateForPostLeadFormWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    RenterInfoRenterProfileInsertOrUpdateForPostLeadFormWebApiRequestDto,
    RenterInfoRenterProfileInsertOrUpdateForPostLeadFormWebApiResponseDto
  >(
    {
      endpoint: RenterInfoRenterProfileWebApiHandler_insertOrUpdateForPostLeadForm_Path,
      method: 'POST',
      contextPath: '/renter-info',
      postData: postData,
    },
    client,
  );
};

export const RenterInfoRenterProfileWebApiHandler_insertOrUpdateForStandalonePage_Path =
  '/api/web/v1/renterProfile/insertOrUpdateForStandalonePage';

/**
 * Insert or update renter profile for standalone page
 */
export const RenterInfoRenterProfileWebApiHandler_insertOrUpdateForStandalonePage = (
  postData: RenterInfoRenterProfileInsertOrUpdateForStandaloneRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    RenterInfoRenterProfileInsertOrUpdateForStandaloneRequestDto,
    RenterInfoRenterProfileStandalonePageWebApiResponse
  >(
    {
      endpoint: RenterInfoRenterProfileWebApiHandler_insertOrUpdateForStandalonePage_Path,
      method: 'POST',
      contextPath: '/renter-info',
      postData: postData,
    },
    client,
  );
};
